import React from 'react';
import MaterialTable from '@material-table/core';
import { SchemaModel } from '../../../models/schemaModel';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';

type Props = {
  readonly schemas: SchemaModel[];
  readonly isLoading: boolean;
  readonly onDeleteClick: (schemaName: string) => void;
};

type SchemaRow = {
  readonly id: string;
  readonly name: string;
  readonly commitId: string;
};

const SchemasTable = (props: Props) => {
  const { schemas, isLoading, onDeleteClick } = props;

  const schemaRows: SchemaRow[] = schemas.map(schema => ({
    id: schema.name,
    name: schema.name,
    commitId: schema.headCommitId,
  }));

  return (
    <MaterialTable
      title='Schemas'
      data={schemaRows}
      isLoading={isLoading}
      columns={[
        {
          title: 'Name',
          field: 'name',
          defaultSort: 'asc',
        },
        {
          title: 'Commit',
          field: 'commitId',
        }
      ]}
      actions={[
        schemaRow => ({
          icon: () => <DeleteIcon color='primary' />,
          tooltip: 'Remove schema',
          onClick: () => onDeleteClick(schemaRow.name),
        }),
      ]}
      options={{
        padding: 'dense',
        selection: false,
        pageSizeOptions: [10, 25, 50],
        pageSize: 10,
        actionsColumnIndex: 3,
        headerStyle: {
          fontWeight: 'bold',
        },
      }}
      components={{
        Container: props => <Paper elevation={1} {...props} />
      }}
    />
  );
};

export default SchemasTable;
